"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CommunicationInstanceAllMappedStatus;
(function (CommunicationInstanceAllMappedStatus) {
    CommunicationInstanceAllMappedStatus["Queued"] = "Queued";
    CommunicationInstanceAllMappedStatus["Mailed"] = "Mailed";
    CommunicationInstanceAllMappedStatus["QueueError"] = "QueueError";
    CommunicationInstanceAllMappedStatus["Processed"] = "Processed";
    CommunicationInstanceAllMappedStatus["ProcessError"] = "ProcessError";
    CommunicationInstanceAllMappedStatus["Delivered"] = "Delivered";
    CommunicationInstanceAllMappedStatus["Sent"] = "Sent";
    CommunicationInstanceAllMappedStatus["Sending Error"] = "Sending Error";
    CommunicationInstanceAllMappedStatus["InTransit"] = "In-Transit";
    CommunicationInstanceAllMappedStatus["OutForDelivery"] = "Out for Delivery";
    CommunicationInstanceAllMappedStatus["ReturnedToSender"] = "Returned to Sender";
    CommunicationInstanceAllMappedStatus["Printed"] = "Printed";
    CommunicationInstanceAllMappedStatus["Issue"] = "Issue";
    CommunicationInstanceAllMappedStatus["ProcessedForDelivery"] = "Processed for Delivery";
    CommunicationInstanceAllMappedStatus["PickupAvailable"] = "Available for Pickup";
})(CommunicationInstanceAllMappedStatus = exports.CommunicationInstanceAllMappedStatus || (exports.CommunicationInstanceAllMappedStatus = {}));
//# sourceMappingURL=CommunicationInstanceAllMappedStatus.js.map